<template>
  <div id="#wrapper" class="t-wrapper" >
      <Header></Header>
      <main :class="{'t-mainControl': $route.path !== '/'}">
          <router-view></router-view>

          <transition name="mainFade">
              <small-dialog v-if="visible"></small-dialog>
          </transition>
      </main>
      <Footer></Footer>
      <div @click.prevent="showModal" class="t-feedBackBtnWrapper js-t-feedBackBtnWrapper">
            <div class="t-feedBackBtnIconHolder">
                <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 5C0 2.23858 2.23858 0 5 0H25C27.7614 0 30 2.23858 30 5V17.2C30 19.9614 27.7614 22.2 25 22.2H19.05L16.6087 25.5051C15.8093 26.5875 14.1907 26.5875 13.3913 25.5051L10.95 22.2H5C2.23858 22.2 0 19.9614 0 17.2V5ZM5 2C3.34315 2 2 3.34315 2 5V17.2C2 18.8569 3.34315 20.2 5 20.2H11.4545C11.7719 20.2 12.0704 20.3506 12.2589 20.6059L15 24.3169L17.7411 20.6059C17.9296 20.3506 18.2281 20.2 18.5455 20.2H25C26.6569 20.2 28 18.8569 28 17.2V5C28 3.34315 26.6569 2 25 2H5Z" fill="#4085D5"/>
                </svg>
            </div>
            <span class="t-feedBackBtnTitle">Оставить заявку</span>
      </div>
      <success-message v-if="visibleModals"></success-message>
  </div>
</template>



<script>
    import Header from './header/Header'
    import Footer from './footer/Footer'
    import { mapGetters, mapMutations } from 'vuex'
    export default {
        metaInfo: {
            title: 'Перспектива | Главная',
        },
        data() {
            return {
                dialogActive: true,
                bottomHelp: window.innerWidth > 767?48:86,
                pxToTop: 0,
            }
        },
        components: {
            'Header': Header,
            'Footer': Footer
        },
        computed: {
            ...mapGetters('smallModal',{
                visible: 'call',
            }),
            ...mapGetters('modals',{
                visibleModals: 'callModalVis',
            }),
            mainStyle(){
                // return {'margin-top': this.$route.meta.modal?-this.pxToTop:0 }
                return {'margin-top':0 }
            }
        },
        methods: {
            ...mapMutations('smallModal',['showModal']),

            help() {
                let getFeedBackBtn = this.$el.querySelector('.js-t-feedBackBtnWrapper');
                let getFooter = this.$el.querySelector('footer');
                let footerTop = getFooter.getBoundingClientRect().top;
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.scrollTop;
                let getThisPosition = scrollTop + window.innerHeight;
                let footerOffset = footerTop + scrollTop;

                getThisPosition < footerOffset ? getFeedBackBtn.style.bottom = `${this.bottomHelp}px` : getFeedBackBtn.style.bottom = `${this.bottomHelp + getThisPosition - footerOffset}px`;
                // this.pxToTop = scrollTop;
                // console.log(this.pxToTop);
            },
        },
        created () {
            window.addEventListener('scroll', this.help, false);
        },
        mounted() {

        },
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/vue_components/App.vue